import red from "@material-ui/core/colors/red";
import tccStyles from "../styles";

const StagingTheme = {
    palette: {
        primary: { main: tccStyles.stagingColor.primary, contrastText: "#fff" },
        secondary: { main: tccStyles.stagingColor.secondary },
        error: red,
        contrastThreshold: 3,
        tonalOffset: 0.2
    },
    typography: {
        // Use the system font instead of the default Roboto font.
        fontSize: "medium"
    },
    overrides: {
        MuiCard: {
            // override the styles of all instances of this component
            root: {
                // Name of the rule
                overflow: "visible" // Some CSS
            }
        }
    }
};

export default StagingTheme;



// WEBPACK FOOTER //
// ./src/common/themes/stagingTheme.js